import React from 'react';
import Sidebar from './Sidebar';
import { useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../services/auth/auth';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const isChat = location.pathname === '/chat';

  const handleLogout = async () => {
    try {
      await authService.logout();
      navigate('/login');
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  return (
    <div className="flex h-screen bg-[#0A0A0B]">
      <Sidebar onLogout={handleLogout} />
      <div className={`flex-1 overflow-auto ${isChat ? 'p-6' : ''}`}>
        {children}
      </div>
    </div>
  );
}
